/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_LabelInputs */

const en_projects_label = /** @type {(inputs: Projects_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected work`)
};

const lv_projects_label = /** @type {(inputs: Projects_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izlase`)
};

/**
* | output |
* | --- |
* | "Selected work" |
*
* @param {Projects_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const projects_label = /** @type {((inputs?: Projects_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_projects_label(inputs)
	return en_projects_label(inputs)
});